export const CUSTOM_PAGE_ORDER_KEY = '__customPageOrder';

const normalizePageId = (value: any): number | null => {
  const id = Number(value);
  return Number.isFinite(id) ? id : null;
};

export const getCustomPageOrder = (pagesConfig: any): number[] => {
  const raw = pagesConfig?.[CUSTOM_PAGE_ORDER_KEY];
  if (!Array.isArray(raw)) return [];

  const seen = new Set<number>();
  const normalized: number[] = [];
  raw.forEach((value) => {
    const id = normalizePageId(value);
    if (id === null || seen.has(id)) return;
    seen.add(id);
    normalized.push(id);
  });
  return normalized;
};

export const sortPagesByConfiguredOrder = (pages: any[], pagesConfig: any): any[] => {
  if (!Array.isArray(pages)) return [];
  if (pages.length <= 1) return [...pages];

  const order = getCustomPageOrder(pagesConfig);
  if (order.length === 0) return [...pages];

  const rankMap = new Map<number, number>();
  order.forEach((id, index) => {
    rankMap.set(id, index);
  });

  return pages
    .map((page, index) => ({ page, index }))
    .sort((a, b) => {
      const aId = normalizePageId(a.page?.id);
      const bId = normalizePageId(b.page?.id);
      const aRank = aId === null ? undefined : rankMap.get(aId);
      const bRank = bId === null ? undefined : rankMap.get(bId);

      if (aRank !== undefined && bRank !== undefined) return aRank - bRank;
      if (aRank !== undefined) return -1;
      if (bRank !== undefined) return 1;
      return a.index - b.index;
    })
    .map(({ page }) => page);
};
